import { useFeatures } from './useFeatures';
import { useInternalUser } from './use-internal-user';

/**
 * Hook returning whether BYOC (Bring Your Own Claude) should be surfaced to
 * the current user. True when the `byoc` feature flag is on OR the user is an
 * OptiSigns internal user (platform admin / staff email domain).
 *
 * Every BYOC render site (settings card, workspace selector, credit warnings,
 * billing CTAs) should gate on this hook rather than `features.byoc` directly.
 *
 * While loading we return `enabled: false` to avoid a flash of BYOC UI for
 * general users on flag-off envs (the features default is `true` to keep
 * local/sandbox dev green, which would otherwise briefly show BYOC in prod
 * during the initial fetch window).
 */
export function useByocEnabled(): { enabled: boolean; loading: boolean } {
  const { features, loading: featuresLoading } = useFeatures();
  const { isInternalUser, loading: internalLoading } = useInternalUser();
  const loading = featuresLoading || internalLoading;
  return {
    enabled: !loading && (features.byoc || isInternalUser),
    loading,
  };
}
